import styled from '@emotion/styled';
import { ReactNode } from 'react';

export type DocumentWrapperProps = {
  children: ReactNode;
};

const StyledDocument = styled('div')`
  ol {
    counter-reset: item;
  }

  li {
    margin: 10px 0;
  }

  ol > li {
    counter-increment: item;
  }

  ol ol > li {
    display: block;
  }

  ol ol > li:before {
    content: counters(item, '.') '. ';
    margin-left: -20px;
  }
  ul,
  ol {
    padding-left: 16px;
  }
`;

export const DocumentWrapper = ({ children }: DocumentWrapperProps) => {
  return <StyledDocument>{children}</StyledDocument>;
};
